import React from 'react';

class RowItemCapNhatNguoiDung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  openDialog() {
    let vaiTro = this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.loaiVaiTro;
    let coQuanQuanLyId = this.props.item.donViCongChuc.coQuanQuanLyId;
    let nguoiDungHienTai = this.props.item.hoVaTen;
    let vaiTroNguoiDungHienTai = this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten;
    let idNguoiDungHienTai = this.props.item.congChucId;
    this.props.openDialog(vaiTro, coQuanQuanLyId, nguoiDungHienTai, vaiTroNguoiDungHienTai, idNguoiDungHienTai);
  }

  render() {
    let Item = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.hoVaTen ? this.props.item.hoVaTen : ''}</td>
        <td>{Item.nguoiDungCongChuc && Item.nguoiDungCongChuc.vaiTroMacDinhInfo ? Item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten : ''}</td>
        <td>
          <span className='itt-redirect pointer' onClick={this.openDialog.bind(this)}>Xử lý</span>
        </td>
      </tr>
    )
  }
}

export default RowItemCapNhatNguoiDung;



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemCapNhatNguoiDung.jsx